import { Component, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ConfiguracoesGeraisComponent } from '../configuracoes-gerais/configuracoes-gerais.component';
import { NavbarComponent } from "../navbar/navbar.component";
import { ConfiguracaoAlimentadoraComponent } from '../configuracao-alimentadora/configuracao-alimentadora.component';
import { ConfiguracaoFalhaAlertaComponent } from '../configuracao-falha-alerta/configuracao-falha-alerta.component';
import { ConfiguracaoOperacaoComponent } from '../configuracao-operacao/configuracao-operacao.component';
import { NgIf } from '@angular/common';
import { DialogConfiguracaoParametroComponent } from '../dialog-configuracao-parametro/dialog-configuracao-parametro.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { DialogLoginComponent } from './dialog-login/dialog-login.component';
import { DialogAgviewConnectService } from 'app/services/dialog-agview-connect/dialog-agview-connect.service';
import { ConfiguracaoLicencasComponent } from '../configuracao-licenca/configuracao-licencas.component';
import { AutenticacaoConfiguracaoLicencaService } from 'app/services/agview-connect/autenticacao-configuracao-licenca/autenticacao-configuracao-licenca.service';

@Component({
  selector: 'app-tela',
  standalone: true,
  imports: [NgIf, DialogConfiguracaoParametroComponent, DialogLoginComponent, NavbarComponent],
  templateUrl: './tela.component.html',
  styleUrl: './tela.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [ style({ opacity: 0 }), animate('200ms ease-out', style({ opacity: 1 })) ]),
      transition(':leave', [ animate('100ms ease-in', style({ opacity: 0 })) ])
    ])
  ]
})
export class TelaComponent implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;
  public telaLicenca: boolean = false;
  ref!: ComponentRef<any>;
  public telasDisponiveis: any = {
    'configuracoes/alimentadora': ConfiguracaoAlimentadoraComponent,
    'configuracoes/operacao': ConfiguracaoOperacaoComponent,
    'configuracoes/falha-alerta': ConfiguracaoFalhaAlertaComponent,
    'configuracoes/licenca': ConfiguracaoLicencasComponent,
    'configuracoes': ConfiguracoesGeraisComponent,
  }
  public telaAtual: any = this.telasDisponiveis["configuracoes"];
  public dialogVisivel: boolean = false;
  public dialogLoginVisivel: boolean = false;

  constructor(
    private readonly dialogAgviewConnectService: DialogAgviewConnectService,
    private autenticacaoConfiguracaoLicencaService: AutenticacaoConfiguracaoLicencaService
  ) { }

  ngOnInit(): void {
    this.criarComponente();
    this.observarMudancasDialog();
  }

  public voltarTelaConfigsGerais() {
    this.telaAtual = this.telasDisponiveis["configuracoes"];
    this.criarComponente();
  }

  public irParaTelaConfiguracaoLicenca() {
    this.dialogLoginVisivel = false;
    this.telaAtual = this.telasDisponiveis["configuracoes/licenca"];
    this.telaLicenca = ConfiguracaoLicencasComponent === this.telaAtual;
    this.criarComponente();
  }

  public criarComponente() {
    this.container.clear();
    this.ref = this.container.createComponent(this.telaAtual);

    if (this.ref.instance.trocarTela) {
      this.ref.instance.trocarTela.subscribe((rota: string) => {
        this.telaAtual = this.telasDisponiveis[rota];
        this.telaLicenca = ConfiguracaoLicencasComponent === this.telaAtual;

        this.criarComponente();
      });
    }

    if (this.ref.instance.mostrarDialogLogin) {
      this.ref.instance.mostrarDialogLogin.subscribe(() => {
        this.mostrarDialogLogin();
      });
    }
  }

  public observarMudancasDialog() {
    this.dialogAgviewConnectService.dialogState$.subscribe((dialog: { open: boolean, data?: any }) => {
      this.dialogVisivel = dialog.open;
    });
  }

  public mostrarDialogLogin(): void {
    if (this.autenticacaoConfiguracaoLicencaService.isLoggedIn()) {
      this.irParaTelaConfiguracaoLicenca();

      return;
    };

    this.dialogLoginVisivel = true;
  }
}
